import { render, staticRenderFns } from "./ProjectForms.vue?vue&type=template&id=5d0b9552&scoped=true"
import script from "./ProjectForms.vue?vue&type=script&lang=js"
export * from "./ProjectForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b9552",
  null
  
)

export default component.exports